import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src="/images/logo.png" alt="LOGO" width={"30px"} />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fas fa-bars"></i>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" to="/">
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link active" to="/find/services">
                  Find Services
                </Link>
              </li>

              {/* <li className="nav-item">
                                <Link className="nav-link active" to='/profSignIn'>Switch to Professional</Link>
                            </li> */}

              <li className="nav-item">
                <Link className="nav-link active" to="/signin">
                  User
                </Link>
              </li>

              <li className="nav-item">
                <a className="nav-link active" href="#">
                  <i className="fa-solid fa-mobile-screen-button" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
